import { render } from "./ScholarshipOptInContent.vue?vue&type=template&id=27bf65d0&scoped=true&ts=true"
import script from "./ScholarshipOptInContent.vue?vue&type=script&lang=ts"
export * from "./ScholarshipOptInContent.vue?vue&type=script&lang=ts"

import "./ScholarshipOptInContent.vue?vue&type=style&index=0&id=27bf65d0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bf65d0"]])

export default __exports__